import { OrgPrefsDocument, useUpdateOrgPrefsMutation } from 'src/generated/mloop-graphql';

import { OrgPrefName } from 'src/utils/api/org/constants';

import { AllOrgPrefName } from './types';

export function useUnsetOrgPref(prefName: AllOrgPrefName | OrgPrefName, onCompleted?: () => void) {
  const [update] = useUpdateOrgPrefsMutation({
    onCompleted,
  });

  return () => {
    return update({
      variables: {
        input: {
          prefName,
        },
      },
      refetchQueries: [OrgPrefsDocument],
    });
  };
}
